import { AppFormSection } from '../ui/AppFormSection';
import { useLocalization } from '../lib/hooks/useLocalization';
import { Product } from '../processes/CMS/processes/management/pages/FindersAndProductsPage/lib/Product';

export function ProductExternalPrefillIdFormItem(props) {
  const { label } = useLocalization().translations.unique.formItems.externalPrefillId;
  const { formItemProps, textFieldProps } = props;

  return (
    <AppFormSection
      formItemProps={{
        name: Product.EXTERNAL_ID,
        ...formItemProps,
      }}
      textFieldProps={{
        label,
        ...textFieldProps,
      }}
    />
  );
}
